/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import React, {useCallback} from "react";
import styled from "styled-components";
import ReactToPrint from "react-to-print";
import ReactToPdf from "react-to-pdf";

import {InvoicePrint} from "./InvoicePrint";
import PrintButton from "../../../../../components/Common/PrintButton";
import {CCard, CCardBody, CCardHeader, CCol, CFormGroup, CRow} from "@coreui/react";
import CancelButton from "../../../../../components/Common/CancelButton";
import CloseButton from "../../../../../components/Common/CloseButton";
import NewButton from "../../../../../components/Common/NewButton";
import html2canvas  from "html2canvas";

import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import fs from 'fs';
import { Whoami } from "../../../../../core/authentication";
// const fs = require('fs')

const ref = React.createRef();

const Container = styled.div`
  height: auto;
  height: 100%;
  overflow-y: auto;
  width: 270;
  min-width: 911px;

`;


class InvoicePrintGraphed extends React.Component {



  escFunction = (event) => {
    if(event.keyCode === 27) {
      this.props.conClose && this.props.conClose()
    }
  };

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
    return () => {
      document.removeEventListener("keydown", this.escFunction, false);
    };
  }


  render() {
    const { ...other } = this.props;
    return (
      <Container ref={ref}>
      <CCard>
      {/* <ReactToPdf targetRef={ref} filename="div-blue.pdf" options={{
            orientation: 'landscape',
            unit: 'in',
            format: [4,2]
        }}>
        {({toPdf}) => (
            <button onClick={toPdf}>Generate pdf</button>
        )}
      </ReactToPdf> */}

        {
          Whoami().id != null && (
            <CCardHeader>
          <CFormGroup row>
            <CCol md="6">
              <h4 className="card-title mb-0">Invoices</h4>
              <div className="small text-muted">Printing</div>
            </CCol>
            <CCol md="6">
              <CRow className="float-right">

                  <ReactToPrint
                    pageStyle={{ size: "auto", margin: "0mm" }}
                    trigger={() => (
                      <PrintButton/>
                    )}
                    content={() => this.componentRef}
                  />

                  <CloseButton
                    value={"Close"}
                    onClick={()=>{
                      this.props.conClose && this.props.conClose()
                    }}
                  />

              </CRow>

            </CCol>
          </CFormGroup>
        </CCardHeader>
          )
        }
        <CCardBody>
        {/* <ReactToPdf>
        {({toPdf, targetRef}) =>  (
          <div onClick={toPdf} ref={targetRef}>
            <InvoicePrint {...other} />
          </div>
        )}
      </ReactToPdf> */}
          <InvoicePrint ref={el => (this.componentRef = el)} {...other} />
        </CCardBody>
      </CCard>
      </Container>
    );
  }
}

export { InvoicePrintGraphed };
export default InvoicePrintGraphed;
